import { useEffect } from "react";
import { usePurchaseV2Store } from "../../../store";
import PaymentDrawTonightInterfaceStore from "../../interface/PaymentDrawTonightInterface";

const useFixPaymentAction = () => {
  const createAndRetryPaymentInvoice = usePurchaseV2Store(
    (state) => state.createAndRetryPaymentInvoice
  );
  const selectedProduct = usePurchaseV2Store((state) => state.selectedProduct);

  useEffect(() => {
    const { setOnCreateFixPayment, setSelectedProduct } =
      PaymentDrawTonightInterfaceStore.getState();
    setOnCreateFixPayment(createAndRetryPaymentInvoice);
    setSelectedProduct(selectedProduct);
  }, [createAndRetryPaymentInvoice, selectedProduct]);
};

export default useFixPaymentAction;
